import React from "react";
import { Modal } from "react-bootstrap";

export const VideoModal = ({
  show,
  onHide,
  videoSrc,
  videoTitle,
  videoDescription,
  videoType = "video/mp4",
}) => {
  return (
    <Modal show={show} onHide={onHide} dialogClassName="help-page-video-modal">
      <Modal.Header closeButton>
        <Modal.Title>{videoTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-5 py-4">
        <div style={{ position: "relative" }}>
          <div
            className="panel-inset-overlay"
            style={{
              boxShadow: "0px 0px 15px rgba(0,0,0,.3)",
              borderRadius: "1rem",
            }}
          ></div>
          <video
            className="diligent-client-portal-demo-video"
            style={{
              borderRadius: "1rem",
              display: "block",
              // border: "2px solid gray",
              boxShadow: "0px 0px 5px rgba(0,0,0, 1) inset",
            }}
            controls
            autoPlay
          >
            <source src={videoSrc} type={videoType} />
          </video>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};
